// Cena 4 — Atendimentos (áudio ~18s)
// Spotlight no gerenciador de tickets, clique real na aba Aguardando,
// um ticket fictício da Maria aparece pedindo aceite; o cursor clica em
// ACEITAR, o ticket vira ATENDENDO, toast comemora e voltamos para a
// aba Atendendo.
const TM = "[data-tour='tickets-manager']";
const TAB_PENDING = "[data-tour='tab-pending']";
const TAB_OPEN = "[data-tour='tab-open']";
const TICKET = "[data-demo='ticket']";
const ACCEPT = "[data-demo='accept']";

export default async function tickets(ctx) {
	// "Essa é a tela de Atendimentos... é aqui que a mágica acontece!"
	await ctx.waitFor(TM);
	ctx.spotlight(TM);
	await ctx.wait(900);

	// "Em Aguardando ficam os clientes novos esperando alguém aceitar."
	await ctx.waitFor(TAB_PENDING);
	await ctx.cursorTo(TAB_PENDING, { duration: 850 });
	await ctx.wait(500);
	await ctx.click(TAB_PENDING, { real: true });
	await ctx.wait(1100);

	// "Cada conversa vira um ticket, como esse exemplo da Maria."
	const ticket = ctx.mount("ticketRow", TM, {
		name: "Maria Souza",
		initial: "M",
		color: "#8B5CF6",
		msg: "Oi! Queria saber o valor do plano…",
		time: "agora",
		badge: 2,
		accept: true,
		status: "AGUARDANDO",
		style: { position: "absolute", top: 150, left: 10, right: 10 },
	});
	await ctx.waitFor(TICKET);
	await ctx.wait(400);
	await ctx.cursorTo(TICKET, { duration: 750 });
	await ctx.wait(1900);

	// "Um clique em Aceitar..."
	await ctx.waitFor(ACCEPT);
	await ctx.cursorTo(ACCEPT, { duration: 700 });
	await ctx.wait(600);
	await ctx.click(ACCEPT);
	await ctx.wait(500);

	// "...e a conversa é sua!"
	ctx.update(ticket, { status: "ATENDENDO", accept: false, badge: 0 });
	await ctx.wait(700);
	const toast = ctx.mount("toast", TM, {
		icon: "🤝",
		text: "Conversa assumida!",
	});
	await ctx.wait(2600);
	ctx.unmount(toast);
	await ctx.wait(400);

	// "Ela vai direto para a aba Atendendo, junto com suas conversas ativas."
	await ctx.waitFor(TAB_OPEN);
	await ctx.cursorTo(TAB_OPEN, { duration: 800 });
	await ctx.wait(500);
	await ctx.click(TAB_OPEN, { real: true });
	await ctx.wait(1200);

	ctx.spotlight(null);
	await ctx.cursorTo({ sel: TM, ax: 0.55, ay: 0.5 }, { duration: 800 });
	await ctx.wait(400);
}
